export const siteConfig = {
  name: 'PG征途国际',
  fullName: 'PG征途国际下载安装',
  tagline: '官方正版客户端一键安装指南',
  description: 'PG征途国际下载安装全流程指南，提供官方正版客户端安卓iOS最新版本，安全无病毒，一键下载安装即玩，支持新手礼包领取。',
  url: 'https://pgzhengtu.com',
};

export const categories = [
  { slug: 'xiazai-jiaocheng', name: '下载教程', icon: 'ri-download-cloud-2-line', description: 'PG征途国际安卓iOS官方正版客户端下载全流程教程' },
  { slug: 'anzhuang-zhinan', name: '安装指南', icon: 'ri-install-line', description: 'PG征途国际手游安装步骤详解与常见问题处理' },
  { slug: 'xinshou-zhinan', name: '新手指南', icon: 'ri-rocket-line', description: 'PG征途国际新手入门攻略与礼包领取教程' },
  { slug: 'youxi-gonglue', name: '游戏攻略', icon: 'ri-sword-line', description: 'PG征途国际游戏玩法攻略与进阶技巧分享' },
  { slug: 'changjian-wenti', name: '常见问题', icon: 'ri-question-answer-line', description: 'PG征途国际下载安装使用中的常见问题解答' },
  { slug: 'zuixin-zixun', name: '最新资讯', icon: 'ri-newspaper-line', description: 'PG征途国际最新版本更新与活动资讯' },
];

export const articles = [
  {
    slug: 'pg-zhengtu-android-xiazai-jiaocheng',
    title: 'PG征途国际安卓最新版本官方正版下载教程（2025版）',
    excerpt: '详细介绍PG征途国际安卓客户端官方正版下载全流程，包含APK文件安全校验、安装权限设置等关键步骤。',
    content: `<p>PG征途国际作为一款深受玩家喜爱的手游，官方持续为安卓用户提供最新版本的客户端下载服务。本文将为大家详细介绍PG征途国际安卓版官方正版的完整下载教程。</p>
<h2>一、下载前的准备工作</h2>
<p>在开始下载PG征途国际安卓客户端之前，请确保您的设备满足以下条件：安卓系统版本需在8.0及以上，手机存储空间至少预留5GB可用空间，网络环境稳定建议使用WiFi下载。</p>
<h2>二、官方正版下载步骤</h2>
<p>步骤一：打开PG征途国际官方网站，进入下载页面。步骤二：选择安卓版本下载入口，点击"安卓下载"按钮。步骤三：系统将自动下载最新的APK安装包文件，请耐心等待下载完成。步骤四：下载完成后，点击安装包文件进行安装。</p>
<h2>三、安装注意事项</h2>
<p>首次安装PG征途国际时，系统可能会提示"未知来源应用"警告，请前往手机设置中的安全选项，开启"允许安装未知来源应用"权限后即可正常安装。安装完成后建议立即进行病毒扫描确保安全。</p>
<h2>四、注册与登录</h2>
<p>安装完成后打开PG征途国际客户端，新用户可选择手机号注册或第三方账号快速登录。注册完成后可领取专属新手礼包。</p>`,
    category: 'xiazai-jiaocheng',
    imageSeq: 'article-android-download',
    date: '2025-08-01',
    readTime: '8分钟',
    tags: ['安卓下载', 'APK安装', '官方正版'],
  },
  {
    slug: 'pg-zhengtu-ios-xiazai-anzhuang',
    title: 'PG征途国际iOS苹果版官方正版下载安装完整指南',
    excerpt: 'PG征途国际iOS版本App Store官方下载与安装教程，包含Apple ID区域切换、TestFlight安装等详细步骤。',
    content: `<p>对于苹果iOS用户来说，下载安装PG征途国际同样非常简单。本文将为iOS玩家提供完整的官方正版下载安装指南。</p>
<h2>一、iOS系统要求</h2>
<p>PG征途国际iOS客户端要求设备运行iOS 14.0或更高版本，建议iPhone 8及以上机型，iPad需iPadOS 14.0以上。</p>
<h2>二、App Store官方下载</h2>
<p>打开App Store应用，在搜索栏输入"PG征途国际"，找到官方正版应用后点击"获取"按钮进行下载安装。请认准官方开发者标识，避免下载到仿冒应用。</p>
<h2>三、TestFlight测试版安装</h2>
<p>如果官方版本尚未在App Store上架，可通过TestFlight安装测试版本。首先安装TestFlight应用，然后点击官方提供的邀请链接即可加入测试。</p>
<h2>四、账号注册与数据同步</h2>
<p>安装完成后使用Apple ID或手机号注册PG征途国际账号，支持Game Center数据同步，多设备间游戏进度无缝衔接。</p>`,
    category: 'xiazai-jiaocheng',
    imageSeq: 'article-ios-download',
    date: '2025-08-05',
    readTime: '7分钟',
    tags: ['iOS下载', 'App Store', 'TestFlight'],
  },
  {
    slug: 'pg-zhengtu-anzhuang-changjian-wenti',
    title: 'PG征途国际安装失败常见错误代码及解决方案汇总',
    excerpt: '全面解析PG征途国际安装过程中可能遇到的各种错误代码，提供对应的解决方案，助你顺利安装游戏客户端。',
    content: `<p>在安装PG征途国际客户端的过程中，部分玩家可能会遇到各种安装失败的情况。本文整理了常见的安装错误及解决方案。</p>
<h2>一、错误代码1001：存储空间不足</h2>
<p>此错误表示手机存储空间不足以完成安装。解决方案：清理手机缓存和不常用的应用，确保至少5GB可用空间后重新安装。</p>
<h2>二、错误代码1002：解析包错误</h2>
<p>APK安装包下载不完整或文件损坏导致。解决方案：删除已下载的安装包，重新从官方网站下载完整的APK文件。</p>
<h2>三、错误代码1003：版本不兼容</h2>
<p>当前安卓系统版本过低，不满足PG征途国际最低系统要求。解决方案：将手机系统升级至安卓8.0及以上版本。</p>
<h2>四、错误代码1004：签名冲突</h2>
<p>手机上已安装非官方版本的PG征途国际客户端。解决方案：先卸载旧版本，再安装官方正版客户端。</p>`,
    category: 'anzhuang-zhinan',
    imageSeq: 'article-install-errors',
    date: '2025-07-28',
    readTime: '10分钟',
    tags: ['安装失败', '错误代码', '解决方案'],
  },
  {
    slug: 'pg-zhengtu-xinshou-libao-lingqu',
    title: 'PG征途国际新手注册礼包领取全攻略，海量福利等你拿',
    excerpt: 'PG征途国际新手玩家专属福利指南，包含注册礼包、每日签到奖励、邀请好友奖励等海量福利领取方式。',
    content: `<p>PG征途国际为新注册玩家准备了丰厚的入门福利，本文将详细介绍所有新手可领取的礼包及奖励内容。</p>
<h2>一、注册即送礼包</h2>
<p>新玩家首次注册PG征途国际账号即可获得价值500元的新手大礼包，包含金币x10000、钻石x500、稀有装备箱x1、经验加成卡x3。</p>
<h2>二、每日签到奖励</h2>
<p>连续签到7天可获得额外奖励：第1天金币x1000，第3天钻石x100，第7天高级召唤券x1。连续签到30天更有超值大礼。</p>
<h2>三、邀请好友奖励</h2>
<p>每成功邀请一位好友注册并达到10级，双方均可获得钻石x200和专属头像框奖励。</p>
<h2>四、新手任务奖励</h2>
<p>完成新手引导任务可领取阶段性奖励，全部完成后可获得限定SSR角色和专属武器皮肤。</p>`,
    category: 'xinshou-zhinan',
    imageSeq: 'article-beginner-gifts',
    date: '2025-08-08',
    readTime: '6分钟',
    tags: ['新手礼包', '注册福利', '签到奖励'],
  },
  {
    slug: 'pg-zhengtu-jiaose-peiyang-gonglue',
    title: 'PG征途国际角色培养与战力提升终极攻略',
    excerpt: '深度解析PG征途国际角色培养系统，包含装备强化、技能升级、阵容搭配等核心玩法，助你快速提升战力。',
    content: `<p>在PG征途国际中，合理的角色培养策略是提升战斗力的关键。本文将全面解析角色培养的各个环节。</p>
<h2>一、角色等级提升</h2>
<p>通过完成主线任务、日常任务和副本挑战获取经验值，提升角色等级。建议优先完成每日任务获取稳定经验来源。</p>
<h2>二、装备系统详解</h2>
<p>装备分为白色、绿色、蓝色、紫色、橙色、红色六个品质等级。高品质装备可通过副本掉落、活动和商城获取。装备强化消耗金币和强化石，建议优先强化武器和防具。</p>
<h2>三、技能升级策略</h2>
<p>每个角色拥有四个主动技能和两个被动技能，技能升级消耗技能书和金币。建议优先升级核心输出技能到满级。</p>
<h2>四、阵容搭配推荐</h2>
<p>合理的阵容搭配需要考虑职业互补：坦克型角色前排抗伤，输出型角色中后排输出，辅助型角色提供治疗和增益效果。</p>`,
    category: 'youxi-gonglue',
    imageSeq: 'article-character-build',
    date: '2025-07-25',
    readTime: '12分钟',
    tags: ['角色培养', '战力提升', '装备强化'],
  },
  {
    slug: 'pg-zhengtu-zhanghao-anquan',
    title: 'PG征途国际账号安全防护指南，保护你的游戏资产',
    excerpt: 'PG征途国际账号安全设置完整教程，包含密码设置、绑定手机、二次验证等安全措施，保障游戏账号安全。',
    content: `<p>账号安全是每位PG征途国际玩家都应重视的问题。本文将详细介绍如何全方位保护你的游戏账号。</p>
<h2>一、设置强密码</h2>
<p>建议设置包含大小写字母、数字和特殊符号的组合密码，长度不少于12位。避免使用生日、电话号码等容易被猜到的信息。</p>
<h2>二、绑定手机号</h2>
<p>在账号设置中绑定手机号是保护账号安全的重要措施。绑定后支持手机验证码登录和密码找回功能。</p>
<h2>三、开启二次验证</h2>
<p>建议开启邮箱二次验证或手机二次验证，每次登录新设备时需要进行额外的身份验证，有效防止账号被盗。</p>
<h2>四、警惕钓鱼网站</h2>
<p>请认准PG征途国际官方网站，不要点击来源不明的链接。官方不会通过任何方式索要你的账号密码。</p>`,
    category: 'changjian-wenti',
    imageSeq: 'article-account-security',
    date: '2025-07-20',
    readTime: '5分钟',
    tags: ['账号安全', '密码保护', '防盗指南'],
  },
  {
    slug: 'pg-zhengtu-zuixin-banben-gengxin',
    title: 'PG征途国际2025年8月最新版本更新内容抢先看',
    excerpt: 'PG征途国际8月版本更新全面解读，新增副本、角色平衡调整、UI优化等内容一览，抢先了解最新动态。',
    content: `<p>PG征途国际2025年8月最新版本已正式上线，本次更新带来了大量新内容和优化改进。本文将为大家详细介绍本次更新的全部内容。</p>
<h2>一、新增副本：深渊迷宫</h2>
<p>全新多人组队副本"深渊迷宫"正式上线，支持3-5人组队挑战。副本共设10层，每层都有独特的BOSS和机关，通关可获得限定装备和称号。</p>
<h2>二、角色平衡调整</h2>
<p>本次更新对12个角色进行了技能数值调整，重点加强了坦克型角色的生存能力和辅助型角色的团队增益效果。</p>
<h2>三、UI界面优化</h2>
<p>主界面布局重新设计，战斗界面新增技能冷却倒计时显示，背包系统增加一键整理功能。</p>
<h2>四、限时活动</h2>
<p>版本更新期间将开启"盛夏狂欢"限时活动，参与活动即可获得限定皮肤、头像框和大量钻石奖励。</p>`,
    category: 'zuixin-zixun',
    imageSeq: 'article-version-update',
    date: '2025-08-10',
    readTime: '6分钟',
    tags: ['版本更新', '新内容', '活动资讯'],
  },
  {
    slug: 'pg-zhengtu-wangluo-wenti-jiejue',
    title: 'PG征途国际网络延迟卡顿问题终极解决方案',
    excerpt: '解决PG征途国际游戏中遇到的网络延迟、卡顿、掉线等问题，提供多种实用的网络优化方案。',
    content: `<p>网络问题是影响PG征途国际游戏体验的重要因素之一。本文整理了多种实用的网络优化方案。</p>
<h2>一、切换网络环境</h2>
<p>如果使用WiFi时出现高延迟，建议切换到4G/5G移动网络尝试。反之亦然，找到最适合当前环境的网络连接方式。</p>
<h2>二、清理后台应用</h2>
<p>关闭不必要的后台应用可以释放网络带宽和系统资源，有效减少游戏卡顿现象。</p>
<h2>三、调整游戏画质设置</h2>
<p>在游戏设置中将画质调整为"流畅"模式，可以降低设备负载，减少因性能不足导致的卡顿。</p>
<h2>四、使用游戏加速器</h2>
<p>推荐使用官方合作的游戏加速器服务，可有效降低延迟，提升游戏网络稳定性。</p>`,
    category: 'changjian-wenti',
    imageSeq: 'article-network-fix',
    date: '2025-08-03',
    readTime: '7分钟',
    tags: ['网络延迟', '卡顿解决', '加速器'],
  },
  {
    slug: 'pg-zhengtu-chongzhi-fanli',
    title: 'PG征途国际充值返利活动详解，充多少送多少',
    excerpt: 'PG征途国际最新充值返利活动全面解析，首充双倍、累充奖励、月卡福利等超值活动一览。',
    content: `<p>PG征途国际定期推出各类充值返利活动，让玩家的每一分投入都能获得最大回报。本文将介绍当前所有充值福利活动。</p>
<h2>一、首充双倍奖励</h2>
<p>新玩家首次充值任意金额即可获得双倍钻石返还，并且额外赠送橙色品质武器一把和限定皮肤。</p>
<h2>二、累计充值奖励</h2>
<p>累计充值达到指定档位可领取额外奖励：充值满100元送SSR角色自选箱，满500元送红色品质装备套装，满1000元送限定传说级坐骑。</p>
<h2>三、月卡福利</h2>
<p>购买月卡（30元）每日可领取钻石x100，持续30天，总计可获得钻石x3000，性价比极高。</p>`,
    category: 'youxi-gonglue',
    imageSeq: 'article-recharge',
    date: '2025-08-06',
    readTime: '5分钟',
    tags: ['充值活动', '返利优惠', '月卡福利'],
  },
];

export const faqItems = [
  {
    question: 'PG征途国际下载安装需要付费吗？',
    answer: 'PG征途国际客户端下载和安装完全免费，游戏本体免费游玩。游戏内提供可选的内购项目，但不影响核心游戏体验。',
  },
  {
    question: '安卓和iOS账号数据互通吗？',
    answer: 'PG征途国际支持跨平台账号数据互通功能。使用同一账号登录不同设备（安卓/iOS），游戏进度、角色数据和充值记录将自动同步。',
  },
  {
    question: '如何确认下载的是官方正版客户端？',
    answer: '请务必通过PG征途国际官方网站或官方授权的应用商店（如App Store、官方应用市场）下载。官方客户端安装包带有数字签名验证，安装时可查看开发者信息确认。',
  },
  {
    question: '游戏最低配置要求是什么？',
    answer: '安卓设备需系统版本8.0及以上，RAM 4GB以上，存储空间5GB以上。iOS设备需系统版本14.0及以上，iPhone 8及以上机型。',
  },
  {
    question: '安装后无法打开游戏怎么办？',
    answer: '请尝试以下方法：1）重启手机后重新打开；2）清除游戏缓存数据；3）卸载后重新下载安装；4）检查手机系统是否为最新版本。如问题仍未解决，请联系客服。',
  },
  {
    question: '新手礼包在哪里领取？',
    answer: '新用户注册后，礼包将自动发放至游戏内邮箱。此外，可在游戏主界面的"福利中心"查看和领取每日签到奖励、新手任务奖励等各类福利。',
  },
  {
    question: '游戏支持哪些支付方式？',
    answer: 'PG征途国际支持微信支付、支付宝、Apple Pay等多种主流支付方式，充值安全便捷。',
  },
  {
    question: '如何联系PG征途国际客服？',
    answer: '您可以通过游戏内客服系统、官方网站在线客服、官方微信公众号或发送邮件至客服邮箱与我们取得联系，客服团队将在24小时内回复您的问题。',
  },
];

export const testimonials = [
  { name: '战神阿瑞斯', rating: 5, comment: 'PG征途国际下载安装非常方便，官方正版安全可靠，一键安装就能玩，画面精致玩法丰富，强烈推荐！', date: '2025-08-09' },
  { name: '星辰大海', rating: 5, comment: '下载教程很详细，按照步骤几分钟就安装好了。游戏内容很精彩，新手礼包也很丰厚，好评！', date: '2025-08-08' },
  { name: '龙魂战士', rating: 5, comment: '用了一年多了，PG征途国际一直在更新优化，官方正版下载渠道安全可靠，不用担心病毒问题。', date: '2025-08-07' },
  { name: '月下独酌', rating: 5, comment: 'iOS下载教程很清晰，按照指引在App Store找到了官方正版，安装后流畅运行不卡顿，赞！', date: '2025-08-06' },
  { name: '风之轨迹', rating: 4, comment: '作为老玩家见证了PG征途国际的成长，官方下载渠道一直很稳定，更新及时，客服响应也很快。', date: '2025-08-05' },
  { name: '剑指苍穹', rating: 5, comment: '安卓和iOS都安装了，数据同步很方便。下载教程中提到的注意事项很有用，少走了很多弯路。', date: '2025-08-04' },
];